import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { GetMedicalRequests } from '../../../api/medicalRequestApi';

// BASE FIELD INTERFACE
interface Field {
    key: string;
    value: string | number | null;
}

interface MedicalRequestItem {
    [index: string]: Field;
}

interface RefundItem {
    [index: string]: Field;
}

interface ServiceCategory {
    key: string;
    value: MedicalRequestItem[] | RefundItem;
}

export interface MedicalRequestSection {
    key: string;
    value: ServiceCategory[];
}

interface MedicalRequestsState {
    medicalRequests: MedicalRequestSection[];
    loading: boolean;
    error: string | null;
    status: number | null;
}

const initialState: MedicalRequestsState = {
    medicalRequests: [],
    loading: false,
    error: null,
    status: null,
};

// ASYNC THUNK - GET MEDICAL REQUESTS
export const fetchMedicalRequests = createAsyncThunk(
    'medicalRequests/fetchMedicalRequests',
    async (language: 'az' | 'en' = 'az', { rejectWithValue }) => {
        try {
            const result = await GetMedicalRequests(language);


            if (result.status === 200) {
                const responseData = result.data;



                if (Array.isArray(responseData)) {
                    return {
                        data: responseData as MedicalRequestSection[],
                        status: result.status
                    };
                }

                // If data is wrapped in another property
                if (responseData && typeof responseData === 'object') {
                    // Try common wrapper properties
                    if ('data' in responseData && Array.isArray(responseData.data)) {
                        return {
                            data: responseData.data as MedicalRequestSection[],
                            status: result.status
                        };
                    }
                    if ('result' in responseData && Array.isArray(responseData.result)) {
                        return {
                            data: responseData.result as MedicalRequestSection[],
                            status: result.status
                        };
                    }
                }
            }

            return rejectWithValue({
                error: 'Gözlənilməz cavab strukturu',
                status: result.status
            });

        } catch (error: any) {
            console.error('Fetch error:', error);
            return rejectWithValue({
                error: error?.response?.data?.message || error?.message || 'Bilinməyən xəta',
                status: error?.response?.status || -1
            });
        }
    }
);

// SLICE
const medicalRequestsSlice = createSlice({
    name: 'medicalRequests',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMedicalRequests.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMedicalRequests.fulfilled, (state, action: PayloadAction<{
                data: MedicalRequestSection[];
                status: number;
            }>) => {


                state.loading = false;
                state.medicalRequests = action.payload.data;
                state.status = action.payload.status;
                state.error = null;
            })
            .addCase(fetchMedicalRequests.rejected, (state, action) => {

                state.loading = false;
                const payload = action.payload as { error: string; status: number } | undefined;
                state.error = payload?.error || 'Xəta baş verdi';
                state.status = payload?.status || -1;
            });
    }
});

export default medicalRequestsSlice.reducer;

